import { BASE_URL } from '../../core/constants'
import { SSO_AUTH_URL, SSO_CLIENT_ID } from './'

const ssoAuthLoginUrl = () => {
  const ssoAuthUrl = new URL('/oauth/authorize', SSO_AUTH_URL)

  ssoAuthUrl.searchParams.set('client_id', SSO_CLIENT_ID)
  ssoAuthUrl.searchParams.set('redirect_uri', `${BASE_URL}/verify-code`)
  ssoAuthUrl.searchParams.set('response_type', 'code')

  return ssoAuthUrl
}

const ssoAuthLogoutUrl = () => {
  const ssoLogoutUrl = new URL('/users/sign_out', SSO_AUTH_URL)
  ssoLogoutUrl.searchParams.set('redirect_uri', BASE_URL)

  return ssoLogoutUrl
}

const ssoAuthSignUpUrl = () => {
  const ssoSignUpUrl = new URL('/users/sign_up', SSO_AUTH_URL)

  ssoSignUpUrl.searchParams.set('client_id', SSO_CLIENT_ID)
  ssoSignUpUrl.searchParams.set('redirect_uri', BASE_URL)
  ssoSignUpUrl.searchParams.set('response_type', 'code')

  return ssoSignUpUrl
}

export const LOGIN_URL = ssoAuthLoginUrl()
export const LOGOUT_URL = ssoAuthLogoutUrl()
export const SIGN_UP_URL = ssoAuthSignUpUrl()
export const PROFILE_URL = new URL('/users/edit', SSO_AUTH_URL)
